import { fixNameEnum } from 'ui/utils';

export const mappingTypeActivities = (type: string | undefined) => {
  switch (type) {
    case 'drp':
      return 'Dividend reinvestment';
    default:
      return fixNameEnum(type);
  }
};
